var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    { attrs: { page: "/users", backLink: "/", pageTitle: "Profile Settings" } },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "max-w-7xl mx-auto py-10 px-0 mx-0" },
          [
            _c("update-profile-information-form", {
              attrs: {
                first_name: _vm.$page.props.auth.user.first_name,
                last_name: _vm.$page.props.auth.user.last_name,
                email: _vm.$page.props.auth.user.email,
              },
            }),
            _vm._v(" "),
            _c("jet-section-border"),
            _vm._v(" "),
            _c("update-password-form", { staticClass: "mt-10 sm:mt-0" }),
            _vm._v(" "),
            _vm.$page.props.jetstream.canManageTwoFactorAuthentication
              ? _c(
                  "div",
                  [
                    _c("jet-section-border"),
                    _vm._v(" "),
                    _c("two-factor-authentication-form", {
                      staticClass: "mt-10 sm:mt-0",
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("jet-section-border"),
            _vm._v(" "),
            _c("logout-other-browser-sessions-form", {
              staticClass: "mt-10 sm:mt-0",
              attrs: { sessions: _vm.sessions },
            }),
            _vm._v(" "),
            _c("jet-section-border"),
            _vm._v(" "),
            _c("delete-user-form", { staticClass: "mt-10 sm:mt-0" }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }